import { Icon } from '@drdropin-tech/theseus';
import classNames from 'classnames';

type Option<T> = {
  icon?: string;
  key: string;
  value: T;
};

type Props<T> = {
  options: Option<T>[];
  selectedOption: Option<T>;
  onClick: (value: Option<T>) => void;
  isDisabled?: (key: T) => boolean;
  ariaLabel?: string;
};

export default function SelectPills<T>({
  options,
  selectedOption,
  onClick,
  isDisabled,
  ariaLabel,
}: Props<T>) {
  return (
    <div
      className="mb-4 flex w-full items-center gap-2"
      role="group"
      aria-label={ariaLabel}
    >
      <div className="relative flex gap-2">
        <ul className="flex gap-2">
          {options.map((option) => {
            const isSelected = option.key === selectedOption.key;
            const disabled = isDisabled ? isDisabled(option.value) : false;
            return (
              <li key={option.key} className="snap-start">
                <button
                  type="button"
                  aria-pressed={isSelected}
                  disabled={disabled}
                  className={classNames(
                    {
                      'bg-accent text-black': isSelected,
                      'disabled:pointer-events-none disabled:opacity-50':
                        disabled,
                    },
                    'border-accent focus-visible:outline-primary flex cursor-pointer items-center gap-2 rounded-full border px-4 py-2 text-xs focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2',
                  )}
                  data-testid={`select-pill-${option.value}`}
                  onClick={() => onClick(option)}
                >
                  {option.icon && (
                    <Icon name={option.icon} iconSize="xs" aria-hidden="true" />
                  )}
                  {option.key}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
